export default "__VITE_ASSET__M$DeEc7X__"